import { NoInfer } from "@reduxjs/toolkit/dist/tsHelpers";
import { ReactElement, ReactNode } from "react";
export const VEHICLES_LOADING = "VEHICLES_LOADING";
export const VEHICLES_FAILURE = "VEHICLES_FAILURE";
export const VEHICLES_SUCCESS = "VEHICLES_SUCCESS";

export type VehicleType = {
  vehicles: Array<Vehicles>;
};

export type Vehicles = {
  id: string;
  values: Array<VehicleData>;
};

export type VehicleData = {
  VehicleIgnitionSignalVolts: number;
  EngineRunning: boolean;
  InPark: boolean;
  BMSPackVolts: number;
  SolarAmps: number;
  AlternatorAmps: number;
  CurrentDTCs: string;
  MIL: boolean;
  FuelLevel: number;
  Odometer: number;
  StateOfCharge: number;
  BMSPackAmps: number;
  ShorelineVolts: number;
  HoodClosed: boolean;
  Date: string;
  MCUString: string;
};

export interface VehicleLoading {
  type: typeof VEHICLES_LOADING;
}

export interface VehicleFailure {
  type: typeof VEHICLES_FAILURE;
}

export interface VehicleSuccess {
  type: typeof VEHICLES_SUCCESS;
  payload: Array<Vehicles>;
}

export type VehicleDispatchTypes =
  | VehicleLoading
  | VehicleFailure
  | VehicleSuccess;
